<template>
    <CardPage :section="17" :page="3" :nextDisabled="nextDisabled" ref="cardPage">
        <div>
            <p>
                Whether you are with a one night stand or a client, there are some strategies you can use to protect yourself and maintain your boundaries.
                Scroll through all of the tips below and then match each tip with the “more info” text below.
            </p>
            <p class="font-weight-bold" v-if="currentTip">
                <v-fade-transition mode="out-in">
                    <span :key="currentTip.tip">Tip: {{ currentTip.tip }}</span>
                </v-fade-transition>
            </p>
            <p v-else class="font-weight-bold font-italic">You've matched all the tips!</p>
            <p class="font-weight-bold mb-0">More info:</p>
            <Carousel :length="infoOrder.length" :iconFunction="iconFunction" @change="change">
                <template v-slot:default="slotProps">
                    <v-container fluid pa-0>
                        <v-layout row wrap align-center>
                            <v-flex class="tipInfo" xs12>
                                <p :class="{ matched: tips[infoOrder[slotProps.index]].matched }" v-html="tips[infoOrder[slotProps.index]].info"></p>
                                <div class="check" v-if="tips[infoOrder[slotProps.index]].matched">
                                    <v-avatar class="success">
                                        <v-icon dark>check</v-icon>
                                    </v-avatar>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </template>
            </Carousel>
            <div class="text-xs-center" v-if="!!currentTip">
                <v-btn round color="primary" @click="select()">Select</v-btn>
            </div>
        </div>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            currentIndex: null
        };
    },
    computed: {
        tips: get('section17/tips'),
        infoOrder: get('section17/infoOrder'),
        currentTip: get('section17/currentTip')
    },
    methods: {
        change(index) {
            this.currentIndex = index;
        },
        select() {
            if (this.currentTip.info === this.tips[this.infoOrder[this.currentIndex]].info) {
                this.$refs.modalFeedback.show(true, 'Good job!', () => {
                    this.$store.set(`section17/tips@${this.currentTip.id}.matched`, true);
                    if (!this.nextDisabled()) {
                        this.$refs.cardPage.nextClick();
                    }
                });
            } else {
                this.$refs.modalFeedback.show(false, 'Try again!');
            }
        },
        iconFunction(n, active) {
            if (this.$store.get(`section17/tips@${n}.matched`)) {
                return active ? 'check_circle' : 'check_circle_outline';
            }
        },
        nextDisabled() {
            return !!this.currentTip;
        }
    }
};
</script>

<style scoped>
.tipInfo {
    position: relative;
}
.check {
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(0%, 0%);
}
.matched {
    opacity: 0.5;
}
</style>
